export default __webpack_public_path__ + "static/media/coffee-shop.b1cb3b3e.png";